import React from 'react'
import { gsap, ScrollToPlugin, Power2 } from 'gsap/all'
import { Close } from 'kunstmuseum-icons'

gsap.registerPlugin(ScrollToPlugin)

class NavigationDrawer extends React.Component {
    constructor(props) {
        super(props)

        this.domRef = React.createRef()
        this.closeMenu = this.closeMenu.bind(this)
        this.scrollToChapter = this.scrollToChapter.bind(this)
    }

    componentDidMount() {
        this.animationTimeline = gsap.timeline({
            yoyo: true,
            onReverseComplete: this.props.closeFunc
        })
            .from(this.domRef.current, {
                opacity: 0
            })
            .from(this.domRef.current.querySelector('.inner'), {
                x: '100%'
            }, '-=0.3')

        const menuItems = this.domRef.current.querySelectorAll('.menu-item')
        menuItems.forEach((item) => item.addEventListener('click', this.scrollToChapter))
    }

    closeMenu() {
        this.animationTimeline.reverse()
    }

    preventInnerEvent = (event) => event.stopPropagation()

    scrollToChapter(event) {
        event.preventDefault()

        let chapterHeadline

        // If the chapter menu item doesn't have a href attribute it is most likely a child item that triggered the event. 
        if (event.srcElement.hasAttribute('href')) {
            chapterHeadline = document.querySelector(event.srcElement.getAttribute('href'))
        } else {
            chapterHeadline = document.querySelector(event.srcElement.parentNode.getAttribute('href'))
        }
        const chapterHeadlineRect = chapterHeadline.getBoundingClientRect()
        const scrollTopPos = window.pageYOffset || document.documentElement.scrollTop
        const chapterPos = chapterHeadlineRect.top + scrollTopPos
        
        gsap.to(window, {
            duration: 1,
            scrollTo: chapterPos - 175,
            ease: Power2.easeInOut
        })

        this.closeMenu()
    }

    render() {
        return (
            <div className="navigation-drawer" ref={this.domRef} onClick={this.closeMenu}>
                <div className="inner" onClick={this.preventInnerEvent}>
                    <button className="close-dialog" onClick={this.closeMenu}>
                        <span className="screen-reader-text">Menü schließen</span>
                        <Close className="close" />
                    </button>
                    {this.props.children}
                </div>
            </div>
        )
    }
}

export default NavigationDrawer